import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

// Engagement Incentives
function getExequteQuery(
  oauthTokenHeader: string,
  website_shared_uid: string[],
  start_date: any,
  end_date: any,
  QUERY_ID: any
) {
  const uidParams = website_shared_uid
    .map((uid) => `website_shared_uid=${encodeURIComponent(uid)}`)
    .join("&");
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&${uidParams}`,
    oauthTokenHeader
  );
}

function postExequteQuery(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/incentivezed_traffic/`,
    data,
    oauthTokenHeader
  );
}

function putExequteQuery(
  oauthTokenHeader: string,
  data: any,
  itb_shared_uid: any
) {
  return fetchWrapper.put(
    `${apiUrl}/advertising_management/incentivezed_traffic/?itb_shared_uid=${itb_shared_uid}`,
    data,
    oauthTokenHeader
  );
}

function postDuplicateBudget(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/incentivezed_traffic/multiple/`,
    data,
    oauthTokenHeader
  );
}

export const engagementIncentivesService = {
  getExequteQuery,
  postExequteQuery,
  putExequteQuery,
  postDuplicateBudget,
};
